import { Price } from '@kanda-libs/ks-design-library';
import { CalculationsValues } from '../useCalculations';
import useMonthly from './useMonthly';

export interface CalculationRowMonthlyProps {
  values: CalculationsValues;
}

const CalculationRowMonthly: React.FunctionComponent<CalculationRowMonthlyProps> =
  function ({ values }) {
    const { valid, label } = useMonthly(values);
    if (valid)
      return (
        <div className="ml-auto flex flex-row">
          <Price
            amount={values.amount}
            poundsClassName="text-16-24"
            centsClassName="text-16-24"
            color="text-neutral-700"
          />
          <p className="ml-1"> / month</p>
        </div>
      );
    return <p className="text-16-24 text-right">{label}</p>;
  };

export default CalculationRowMonthly;
